import {
  Box,
  makeStyles
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { getCachedPropertyCompImage, isRemoteImage, loadPropertyCompImage } from "../utils/propertyCompImage";
import { ReportImages } from "../stores/internalValuationReviewStore";


const useStyles = makeStyles(() => ({
  imgContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "100px",
  }
}));

interface PropertyImageProps {
  property: any;
  //only in the report: the photos the server sent as data URIs. When it is there it is the only source (no photo = placeholder)
  reportImages?: ReportImages | null;
  //shown when the property has no photo of its own (the subject uses the photo of its carousel)
  fallbackImage?: string | null;
}

export const PropertyImage = ({ property, reportImages, fallbackImage }: PropertyImageProps) => {
  const [errorLoadingImage, setErrorLoadingImage] = useState(false);
  const [downloadedImage, setDownloadedImage] = useState<string | null>(null);

  const classes = useStyles();

  const storedValue: string = property.propertyImage;
  //a URL (comp tool) is used as it is, anything else is the path of a photo uploaded from the VTR form
  const ownImageSrc = reportImages
    ? (reportImages.compImages?.[property.propertyCompId] ?? null)
    : !storedValue
      ? null
      : isRemoteImage(storedValue)
        ? storedValue
        : (getCachedPropertyCompImage(storedValue) || downloadedImage);
  //(the report only uses what the server sent)
  const imageSrc = ownImageSrc || (reportImages ? null : (fallbackImage || null));

  useEffect(() => {
    if (reportImages || !storedValue || isRemoteImage(storedValue) || getCachedPropertyCompImage(storedValue)) return;

    let active = true;
    loadPropertyCompImage(property.propertyCompId, storedValue).then(url => {
      if (!active) return;
      if (url) {
        setDownloadedImage(url);
      } else {
        setErrorLoadingImage(true);
      }
    });
    return () => { active = false; };
  }, [storedValue, property.propertyCompId, reportImages]);

  useEffect(() => {
    if (!imageSrc) return;

    const img = new Image();
    img.src = imageSrc;

    img.onload = () => setErrorLoadingImage(false);
    img.onerror = () => setErrorLoadingImage(true);
  }, [imageSrc]);

  return (<Box className={classes.imgContainer}>
    {imageSrc && !errorLoadingImage ? (
      <div style={{
        width: "100%",
        height: "130px",
        backgroundImage: `url(${imageSrc})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}></div>
    ) : (
      <p>No Image Available</p>
    )}
  </Box>);
}